import { formatterDateHandle, getErrorCode, isFieldAllEmpty } from "utils/index"
import { fixComponent, id_map, key_lable_map } from "utils/analysisTypeId.js"

export class UpdateGridData {
  constructor(vue) {
    this.context = vue
  }
  //upDateRect：开始生成自由布局组件前的检查
  async upDateData({
    rectAttr,
    restDataUrl,
    ids,
    addCb,
    updateCb,
    hideComponentCb,
    componentBoxUpdateCb,
    updateEleCb,
    showComponentCb,
    componentBoxUpdateOpacity,
  }) {
    this.rectAttr = rectAttr
    this.restDataUrl = restDataUrl
    this.ids = ids
    this.addCb = addCb
    this.updateCb = updateCb
    this.hideComponentCb = hideComponentCb
    this.showComponentCb = showComponentCb
    this.componentBoxUpdateCb = componentBoxUpdateCb
    this.updateEleCb = updateEleCb
    this.componentBoxUpdateOpacity = componentBoxUpdateOpacity
    return {
      ...(await this.getCompleteData()),
      totalRecords: this.totalRecords,
      selectedDates: this.selectedDates || [], // 日历选择器参数
      selectedDateMap: this.selectedDateMap || [], // 日历选择器参数
    }
  }
  //递归查找布局组件中所有的可使用的col
  async getCompleteData() {
    let result, backData
    result = await this.getAppointData()
    if (result?.data?.data.today) {
      backData = result?.data?.data?.datas
      this.totalRecords = result?.data?.data?.datas.length
      // TODO: 日历选择器
      this.selectedDates = result?.data?.data?.dateStrs
      this.selectedDateMap = result?.data?.data?.dateStrsMap
    } else {
      backData = result?.data?.data?.datas?.datas
      this.totalRecords = result?.data?.data?.datas?.totalRecords
    }
    // 需要将当前数据保存在共享数据池中，使用当前组件的myid作为键
    this.context.shareDataPool.setData(
      `gridData-${this.ids.container_id}-${this.ids.rect_id}`,
      JSON.stringify(backData)
    )
    if (backData?.length) {
      if (typeof this.updateEleCb === "function")
        this.updateEleCb(false, "emptyData", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        })
      const completeData = this.getDataInfo(backData)
      console.log("completeData>>>", completeData)
      window.localStorage.setItem("completeData", JSON.stringify(completeData))
      return { completeData: completeData }
    } else {
      if (typeof this.updateEleCb === "function") {
        this.updateEleCb(true, "emptyData", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        })
        // 错误码
        if (result.data.status !== 200 || result.data.code === 0) {
          let errorCode = getErrorCode(result.data.message)
          this.updateEleCb(errorCode, "errorCode", false, null, {
            rect_id: this.ids.rect_id,
            container_id: this.ids.container_id,
            elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
            path: this.ids.path
          })
        }
        // this.updateEleCb("400", "height", false, null, {
        //   rect_id: this.ids.rect_id,
        //   container_id: this.ids.container_id,
        //   elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        //   path: this.ids.path
        // })
        // this.updateEleCb("px", "heightType", false, null, {
        //   rect_id: this.ids.rect_id,
        //   container_id: this.ids.container_id,
        //   elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        //   path: this.ids.path
        // })
      }
      return { completeData: [] }
    }
  }
  async getAppointData() {
    return this.context.asyncTask.add(
      this.context.instance.get(`${this.restDataUrl}`)
    )
  }
  //过滤掉数据中没用的数据和空数据，并给每个数组元素判断出需要增加的组件类型
  getDataInfo(result) {
    let _result = null
    if (this.getDataType === 1) {
      _result = this.convertSearchResults(result)
    } else {
      _result = this.convertnormalResults(result)
    }
    return _result
  }
  // 针对正常图文数据进行处理
  convertnormalResults(result) {
    let _result = JSON.parse(JSON.stringify(result))
    Object.keys(_result).forEach(key => {
      Object.keys(_result[key]).forEach(dataItemKey => {
        // 保留url和publicId
        if (dataItemKey === "url") return
        if (dataItemKey === "publicId") return
        if (dataItemKey === "id") return
        if (dataItemKey === "pageType") return
        if (dataItemKey === "viewNum") return
        if (isNaN(dataItemKey)) {
          delete _result[key][dataItemKey]
        } else {
          if (isFieldAllEmpty(_result, dataItemKey)) {
            delete _result[key][dataItemKey]
          } else {
            const componentShape = fixComponent(dataItemKey, _result[key][dataItemKey].value)
            _result[key][dataItemKey].component_shape = componentShape
          }
        }
      })
    })
    return _result
  }
  // 针对搜索接口返回的数据特殊处理成渲染逻辑能够使用的数据格式
  convertSearchResults(array) {
    console.log("array>>>", array)
    let _result = []
    array.map((item, index) => {
      var keys = Object.keys(item) // 获取对象的所有属性名
      let temp = {}
      for (var i = 0; i < keys.length; i++) {
        // 只需要针对需要走组件渲染的字段进行数据结构改造
        // 保留url
        if (keys[i] === "url") {
          temp.url = item[keys[i]]
          continue
        }
        if (!Object.keys(key_lable_map).includes(keys[i])) continue
        const flag = id_map.filter(ele => ele.description === key_lable_map[keys[i]])[0].flag
        temp[flag] = {
          key: keys[i],
          label: key_lable_map[keys[i]],
          value: item[keys[i]],
          pageType: 1, // 填写 pageType 字段的值
          url: null // 填写 url 字段的值
        }
        // flagId特殊处理，根据内容来确定组件类型
        temp[flag].component_shape = fixComponent(999, item[keys[i]])
      }
      _result.push(temp)
    })
    console.log("_result>>>>", _result)
    return _result
  }
  //开始生成自由布局组件前的检查检查完毕
  // -----------------------------------------------
  // =====================================
  startUpdateGrid(completeData) {
    if (!completeData) {
      return
    }
    for (let i = 0; i < this.rectAttr.cells.length; i++) {
      const cellId = this.rectAttr.cells[i].cellId
      const elementInGridOptions = this.rectAttr.cells[i].elementOptions
      const tempData = completeData[i]
      if (tempData) {
        this.componentBoxUpdateOpacity({
          isShow: true,
          cellId: cellId
        })
        this.componentBoxUpdateCb({
          dataUrl: tempData.url,
          pageType: tempData.pageType,
          dataId: tempData.publicId ? tempData.publicId : tempData.id,
          cellId
        })
        //如果有组件就要走更新流程
        const hasDataK = elementInGridOptions.some(
          ele => ele.filedMapping && ele.filedMapping.hasOwnProperty("value") && ele.filedMapping.value !== null
        )
        if (hasDataK) {
          //如果col中的组件中有字段映射关系就走新逻辑，col中的全部组件都没字段映射关系就走老逻辑
          elementInGridOptions.forEach(ele => {
            let param = {cellId: cellId, elementInDataGridId: ele.elementInDataGridId}
            const dataK = ele?.filedMapping?.value
            const isDate = ele?.filedMapping?.isDate
            const dateStyle = ele?.filedMapping?.dateStyle
            const dataType = ele?.filedMapping?.dataType
            //如果有dataKey 说明有字段映射关系 就优先去那对应映射关系的数据
            if (dataK !== null && !isNaN(dataK) && tempData.hasOwnProperty(dataK)) {
              // 增加日期格式判断，如果是日期字段，需要走日期格式化方法
              let tempDataValue = tempData[dataK].value
              // 如果有dataType 判断获取格式
              if (dataType === "dataKey") {
                tempDataValue = tempData[dataK].key + "：" + tempData[dataK].value
              } else if (dataType === "dataName") {
                tempDataValue = tempData[dataK].key
              }
              // 如果是视频 增加支持云盘判断
              param.option_val = isDate
                ? formatterDateHandle(tempData[dataK].value, dateStyle)
                : ele.videoObjectId
                ? tempData[dataK].objectId
                : tempDataValue
              param.option_name = this.fixOptName([ele.innerElement])
              if (ele.emptyDataShowLocal && !param.option_val) {
                if (ele.innerElement === "cxText") {
                  param.option_val = ele.emptyContent
                }
                if (ele.innerElement === "imageComponent") {
                  param.option_val = ele.emptyImgSrc
                }
              }
              // 图标单独处理 要支持字段匹配也要兼容以前线上搭好的样式
              if (ele.innerElement === "cxIcon") {
                param.option_name = "iconSrc"
              }
              this.updateCb(param)
              // 图标匹配字段 需要修改type为图片
              if (ele.innerElement === "cxIcon") {
                param.option_name = "iconType"
                param.option_val = "img"
                this.updateCb(param)
              }
            } else if (dataK !== null && isNaN(dataK) && tempData.hasOwnProperty(dataK)) {
              // dataKey是viewNum这种形式的键的字段
              param.option_name = this.fixOptName([ele.innerElement])
              let tempDataValue = tempData[dataK]
              let label = dataK === "viewNum" ? "浏览量" : dataK
              // 如果有dataType 判断获取格式
              if (dataType === "dataKey") {
                tempDataValue = label + "：" + tempData[dataK]
              } else if (dataType === "dataName") {
                tempDataValue = label
              }
              param.option_val = tempDataValue
              this.updateCb(param)
            } else {
              // 未绑定字段匹配 不能隐藏组件 显示原本的值
              param.option_name = this.fixOptName([ele.innerElement])
              this.showComponentCb(param)
            }
            // 绑定了字段匹配 但是为空 隐藏组件
            if (dataK !== null && !isNaN(dataK) && !tempData.hasOwnProperty(dataK)) {
              param.option_name = this.fixOptName([ele.innerElement])
              this.hideComponentCb(param)
            }
          })
        } else {
          // col中的组件都没有字段映射 走老逻辑
          elementInGridOptions.forEach(ele => {
            let param = {cellId: cellId, elementInDataGridId: ele.elementInDataGridId}
            const dataK = Object.keys(tempData).find(k => {
            let res
              try {
                res = tempData[k].component_shape && tempData[k].component_shape.find(it => it === ele.innerElement)
              } catch (error) {
                console.log("error", k, tempData[k])
              } finally {
                return res
              }
            })
            // 让文本列表页的icon重新显示出来
            if (ele.innerElement === "cxIcon") {
              param.option_name = this.fixOptName([ele.innerElement])
              this.updateCb(param)
            }
            if (dataK !== undefined && tempData.hasOwnProperty(dataK)) {
              param.option_val = tempData[dataK].value
              param.option_name = this.fixOptName([ele.innerElement])
              this.updateCb(param)
              //老逻辑中 被用了的数据需要删除
              delete tempData[dataK]
            } else if (
              // 仅有这些可以参与数据渲染的组件才需要隐藏
              ele.innerElement === "imageComponent" ||
              ele.innerElement === "cxText" ||
              ele.innerElement === "cxButton" ||
              ele.innerElement === "cxEditor" ||
              ele.innerElement === "cxLabel" ||
              ele.innerElement === "cxIcon"
            ) {
              param.option_name = this.fixOptName([ele.innerElement])
              this.showComponentCb(param, ele.opacity, ele.display)
            }
          })
        }
      } else {
        this.componentBoxUpdateOpacity({
          isShow: false,
          cellId: cellId,
        })  
      }
    }
  }
  //区分不同组件的option_name不一致的问题
  fixOptName(shape) {
    if (
      shape.find(
        it => it === "cxText" || it === "cxDigitRoll" || it === "cxButton" || it === "cxEditor" || it === "cxLabel"
      )
    ) {
      return "content"
    } else if (shape.find(it => it === "cxVideo")) {
      return "videoUrl"
    } else if (shape.find(it => it === "cxAudio")) {
      return "audioUrl"
    } else if (shape.find(it => it === "cxCode")) {
      return "linkUrlVal"
    } else {
      return "imgSrc"
    }
  }
}
